/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetFragmentSocialUploadsByFragmentIdQueryResponse, GetFragmentSocialUploadsByFragmentIdPathParams } from "../models/GetFragmentSocialUploadsByFragmentId";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getFragmentSocialUploadsByFragmentId } from "../axios/getFragmentSocialUploadsByFragmentId";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getFragmentSocialUploadsByFragmentIdQueryKey = (fragmentId: GetFragmentSocialUploadsByFragmentIdPathParams["fragmentId"]) => ["web-app-bff-api", { url: '/fragment-social-uploads/by-fragment/:fragmentId', params: {fragmentId:fragmentId} }] as const

export type GetFragmentSocialUploadsByFragmentIdQueryKey = ReturnType<typeof getFragmentSocialUploadsByFragmentIdQueryKey>

export function getFragmentSocialUploadsByFragmentIdQueryOptions(fragmentId: GetFragmentSocialUploadsByFragmentIdPathParams["fragmentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getFragmentSocialUploadsByFragmentIdQueryKey(fragmentId)
        return queryOptions<GetFragmentSocialUploadsByFragmentIdQueryResponse, ResponseErrorConfig<Error>, GetFragmentSocialUploadsByFragmentIdQueryResponse, typeof queryKey>({
         enabled: !!(fragmentId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getFragmentSocialUploadsByFragmentId(fragmentId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get social uploads for a fragment
 * {@link /fragment-social-uploads/by-fragment/:fragmentId}
 */
export function useGetFragmentSocialUploadsByFragmentId<TData = GetFragmentSocialUploadsByFragmentIdQueryResponse, TQueryData = GetFragmentSocialUploadsByFragmentIdQueryResponse, TQueryKey extends QueryKey = GetFragmentSocialUploadsByFragmentIdQueryKey>(fragmentId: GetFragmentSocialUploadsByFragmentIdPathParams["fragmentId"], options: 
{
  query?: Partial<QueryObserverOptions<GetFragmentSocialUploadsByFragmentIdQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getFragmentSocialUploadsByFragmentIdQueryKey(fragmentId)
         

         const query = useQuery({
          ...getFragmentSocialUploadsByFragmentIdQueryOptions(fragmentId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}